import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=8a8133da&scoped=true"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"
import style0 from "./Preview.vue?vue&type=style&index=0&id=8a8133da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8133da",
  null
  
)

export default component.exports